<template>
  <div class="container">
    <div class="body-style">
      <div style="width:40%;">
        <img
          src="/img/4041.png"
          style="float: right;"
        >
      </div>
      <div class="error-wrapper">
        <h1>
          Page Not Found
        </h1>
        <div class="error-message">
          We can't find the page you're looking for.
        </div>
        <div>
          <br>
          <b-button
            class="button-style"
            to="/"
          >
            Visit Homepage
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'NotFound'
})
export default class extends Vue {
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: bold;
  font-size: 3.4rem;
}

.error-wrapper {
  width: 45%;
  float: left;
  margin-left: 5rem;
}

.error-message {
  font-size: 2.5rem;
  text-align: left;
}

.body-style {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-content: center;
  align-content: center;
  margin-top: 30vh;
}

.button-style {
  color: white;
  background-color: #34ADF6;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}
</style>
